import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { CashReport } from '@spike/payments-model';
import { FunctionComponent } from 'react';
import { formatSalesReportItemValue, salesReportItemvalueType } from 'utils/PaymentsUtils';
import SummaryCard from '../../UI/SummaryCard';

interface SummaryProps {
    cashReport?: CashReport;
    loading?: boolean;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        firstCell: {
            display: 'flex',
            [theme.breakpoints.only('xs')]: {
                justifyContent: 'center'
            },
            [theme.breakpoints.up('sm')]: {
                justifyContent: 'flex-start'
            }
        },
        cell: {
            display: 'flex',
            justifyContent: 'center'
        },
        lastCell: {
            display: 'flex',
            [theme.breakpoints.only('xs')]: {
                justifyContent: 'center'
            },
            [theme.breakpoints.up('sm')]: {
                justifyContent: 'flex-end'
            }
        }
    })
);

export const CashSummary: FunctionComponent<SummaryProps> = props => {
    const classes = useStyles();

    return (
        <Grid
            container
            className={props.className}
            spacing={2}
        >
            <Grid
                item
                xs={12}
                md={2}
                className={classes.firstCell}
            >
                <SummaryCard
                    title="Payments"
                    value={formatSalesReportItemValue(
                        props.cashReport?.paymentsCount,
                        salesReportItemvalueType.Quantity
                    )}
                    info="Number of payments transactions that occurred on the selected date(s)"
                    loading={props.loading}
                />
            </Grid>
            <Grid
                item
                xs={12}
                md={2}
                className={classes.cell}
            >
                <SummaryCard
                    title="Refunds"
                    value={formatSalesReportItemValue(
                        props.cashReport?.refundsCount,
                        salesReportItemvalueType.Quantity
                    )}
                    info="Number of refunds transactions that occurred on the selected date(s)"
                    loading={props.loading}
                />
            </Grid>
        </Grid>
    );
};

export default CashSummary;
